import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { ImpactResponse } from 'services/tenantManagementService';
import { TICKET_IMPACT_SET, TICKET_IMPACT_FETCHING } from './action';

export const ticketImpactReducer = (state = new PersistItemsReducer<ImpactResponse>(), action: PersistItemsActionType<ImpactResponse> | FetchingActionType): PersistItemsReducer<ImpactResponse> => {
	switch (action.type) {
		case TICKET_IMPACT_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case TICKET_IMPACT_SET:
			const { items } = action as PersistItemsActionType<ImpactResponse>;

			const itemsMap: { [id: number]: ImpactResponse } = items.reduce(
                (map: { [id: number]: ImpactResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
